import { render, staticRenderFns } from "./BoxTypeMaster.vue?vue&type=template&id=8b351342"
import script from "./BoxTypeMaster.vue?vue&type=script&lang=js"
export * from "./BoxTypeMaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports